import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text } from '@bigcommerce/big-design';

import { paymentTermCreate } from '../../../redux/actions/paymentTerms';

const NewPaymentTermModal = ({ payload, showNewPaymentTermModal, setShowNewPaymentTermModal, newPaymentTerm }) => {
  const [termName, setTermName] = useState(null);
  const [period, setPeriod] = useState(null);

  const paymentTerm = () => {
    return {
      term_name: termName,
      shipping_terms: period
    }
  }

  const changeName = (event) => {
    let value = event.target.value;
    setTermName(value);
  }

  const changePeriod = (event) => {
    let value = event.target.value;
    setPeriod(value);
  }

  const create = () => {
    newPaymentTerm(payload, paymentTerm());
    setShowNewPaymentTermModal(false);
  }

  return(
    <>
      <Modal
        actions={[
          {
            text: 'Cancel',
            variant: 'subtle',
            onClick: () => setShowNewPaymentTermModal(false),
          },
          { text: 'New Payment Term', onClick: () => create() },
        ]}
        closeOnClickOutside={true}
        closeOnEscKey={true}
        header="New Payment Term"
        isOpen={showNewPaymentTermModal}
        onClose={() => setShowNewPaymentTermModal(false)}
      >
        <H3>New Payment Term</H3>
        <Input
          description="Payment Name"
          label="Payment Name"
          onChange={changeName}
          placeholder="Payment Name"
          type="text"
          value={termName}
          required
        />
        <Input
          description="Payment Period (days)"
          label="Payment Period (days)"
          onChange={changePeriod}
          placeholder="Payment Period (days)"
          type="number"
          min="0"
          value={period}
          required
        />

      </Modal>
    </>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  newPaymentTerm: (payload, paymentTerm) => dispatch(paymentTermCreate(payload, paymentTerm)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewPaymentTermModal);